
/**
 * Allowed value range is [0, 255].
 * Because only these numbers can be stored in a single byte.
 */
export enum SeatOrderType {
  None = 0,
  Ticket = 1,
  Pass = 2,
}
